export const defaultSuccessMessage = 'Операция прошла успешно';
